module.exports = __webpack_public_path__ + "img/hip-ectomorph-female.64f495de.svg";